import { countries, usStates } from './constants';

export const formatProper = (text: string | undefined) => {
  if (!text) return '';
  return text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatUsd = (amount: number, decimals = 2) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount);
};

export const mapCountryCodeToCountry = (countryCode: string): string | undefined => {
  return countries.find((country) => country.code === countryCode)?.name;
};

export const mapStateCodeToState = (stateCode: string): string | undefined => {
  return usStates.find((state) => state.code === stateCode)?.name;
};

export const isTruthy = (value?: string | null) => {
  return value === 'true';
};

export function formatShortUuid(uuid?: string): string {
  if (!uuid) return 'N/A';
  return uuid.substring(0, 8);
}

export function pluralize(count: number, singular: string, plural?: string): string {
  return `${count} ${count === 1 ? singular : (plural ?? `${singular}s`)}`;
}

export function pluralWord(count: number, singular: string, plural?: string): string {
  return count === 1 ? singular : (plural ?? `${singular}s`);
}
